import { Component, OnDestroy, OnInit, inject } from '@angular/core';

import { CONTENT_PLACEHOLDERS } from '../../../common/constants/constants';
import { ContentUtil } from '../../utils/content/content.util';
import { ClientSegmentFacadeService } from '../../services/client-segment-observer/client-segment.service';
import { ClientSegmentContentDTO } from 'src/common/dtos/client-segment.dto';
import { Subject, takeUntil } from 'rxjs';
import { ReplaceParamPipe } from '../../pipes/replace-param/replace-param.pipe';
import { AdvisorComponent } from './advisor/advisor.component';

@Component({
    selector: 'zci-representative-card',
    templateUrl: './representative-card.component.html',
    styleUrls: ['./representative-card.component.scss'],
    imports: [
        ReplaceParamPipe,
        AdvisorComponent,
    ],
})
export class RepresentativeCardComponent implements OnInit, OnDestroy {
    private readonly clientSegmentFacadeService = inject(ClientSegmentFacadeService);

    content = ContentUtil.content;

    contactPersonTypePlaceHolder: string = CONTENT_PLACEHOLDERS.CONTACT_PERSON_TYPE;

    contactName: string = ContentUtil.wealthManagementSupportTeamContent;

    contactPhone: string = ContentUtil.globalRMSupportContactPhoneNumber;

    phoneNumber: string;
    supportName: string;
    supportTeam: string;
    private destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.clientSegmentFacadeService.clientSegmentContent$
            .pipe(takeUntil(this.destroy$))
            .subscribe((content: ClientSegmentContentDTO) => {
                this.phoneNumber = this.contactPhone.replace('${phoneNumber}', content?.phoneNumber)
                this.supportName = content?.supportTeam.replace(' team', '')
                this.supportTeam = this.contactName.replace('${supportTeam}', content?.supportTeam)

            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
